const app = {
  carouselContainerEl: '#js-topPage-carousel-app-container',
  carouselMountEl: '#js-topPage-carousel-app',
  sidebarMountEl: '#js-topPage-sidebar-app',
  articleMountEl: '#js-topPage-articles-app',
  topSearchMountEl: '#js-topPage-search-app',
  topMainMountEl:  '#js-topPage-main',
  topSideBarMountEl: '#js-topPage-sidebar',
  ieDeprecatedAlertEl: '#js-ie-deprecated_announcements'
}

const data = {
  carouselContents: '#json-carousel-contents',
  brandItems: '#json-top-brands-contents',
  productCategories: '#json-product-categories',
  articles: '#json-article-contents',
  announcements: '#json-announcements',
  viewedProducts: '#viewed-products',
  flagTopSearch: '#flag-top-search',
  maxQuantityPrice : '#max-quantity-price',
  topProducts: '#json-product-groups-top-page'
}

export { app, data }
